import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_2 = { class: "d-flex flex-row gap-1" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Found illegal mode, please fix template. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!

  return (this.isFlexMode)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (this.label != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_Label, {
                class: _normalizeClass(_ctx.computedLabelCss),
                for: _ctx.selectId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.label), 1)
                ]),
                _: 1
              }, 8, ["class", "for"]),
              _createVNode(_component_CustomSelect, {
                id: _ctx.selectId,
                class: _normalizeClass(_ctx.computedSelectCss),
                required: this.required,
                disabled: _ctx.disabled,
                options: _ctx.optional ? [{ label: this.defaultLabel, value: null }].concat(_ctx.trueOptions) : _ctx.trueOptions,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
                modelValue: _ctx.modelValue
              }, null, 8, ["id", "class", "required", "disabled", "options", "modelValue"])
            ]))
          : (_openBlock(), _createBlock(_component_CustomSelect, {
              key: 1,
              id: _ctx.selectId,
              class: _normalizeClass(_ctx.computedSelectCss),
              required: this.required,
              disabled: _ctx.disabled,
              options: _ctx.optional ? [{ label: this.defaultLabel, value: null }].concat(_ctx.trueOptions) : _ctx.trueOptions,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
              modelValue: _ctx.modelValue
            }, null, 8, ["id", "class", "required", "disabled", "options", "modelValue"]))
      ], 64))
    : (this.isFormGridMode)
      ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 1 }, {
          label: _withCtx(({ controlId : controlId, class : clazz }) => [
            (this.label != null)
              ? (_openBlock(), _createBlock(_component_Label, {
                  key: 0,
                  class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                  for: controlId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(this.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "for"]))
              : _createCommentVNode("", true)
          ]),
          control: _withCtx(({ id : id }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CustomSelect, {
                type: "text",
                id: id,
                class: _normalizeClass(_ctx.computedSelectCss),
                options: _ctx.optional ? [{ label: this.defaultLabel, value: null }].concat(_ctx.trueOptions) : _ctx.trueOptions,
                required: this.required,
                disabled: _ctx.disabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
                modelValue: _ctx.modelValue,
                wasValidated: _ctx.wasValidated
              }, null, 8, ["id", "class", "options", "required", "disabled", "modelValue", "wasValidated"]),
              _renderSlot(_ctx.$slots, "postWidget")
            ])
          ]),
          _: 3
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_3
        ], 64))
}